import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { SubscriptionDismantleResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const subscriptionDismantle = {
    record(data: typeof Requests.SubscriptionDismantle.Record.Input) {
        return post<typeof data, SubscriptionDismantleResponseTypes.Record>(
            `/subscription-dismantle/record`,
            data,
        );
    },
    create(data: typeof Requests.SubscriptionDismantle.Create.Input) {
        return post<typeof data>("/subscription-dismantle/create", data);
    },
    obtain(id: string) {
        return get<SubscriptionDismantleResponseTypes.Obtain>(
            `/subscription-dismantle/obtain/${id}`,
        );
    },
    dismantleSetup(id: string, data: typeof Requests.SubscriptionDismantle.DismantleSetup.Input) {
        return post<typeof data>(`/subscription-dismantle/dismantle-setup/${id}`, data);
    },
    dismantleCreate(id: string, data: typeof Requests.SubscriptionDismantle.DismantleCreate.Input) {
        return post<typeof data>(`/subscription-dismantle/dismantle-create/${id}`, data);
    },
    dismantleDispatch(id: string) {
        return postEmpty(`/subscription-dismantle/dismantle-dispatch/${id}`);
    },
    dismantleReport(id: string, data: typeof Requests.SubscriptionDismantle.DismantleReport.Input) {
        return post<typeof data>(`/subscription-dismantle/dismantle-report/${id}`, data);
    },
    advance(id: string) {
        return postEmpty(`/subscription-dismantle/advance/${id}`);
    },
    finalize(id: string, data: typeof Requests.SubscriptionDismantle.Finalize.Input) {
        return post<typeof data>(`/subscription-dismantle/finalize/${id}`, data);
    },
    cancel(id: string) {
        return postEmpty(`/subscription-dismantle/cancel/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.SubscriptionDismantle.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/subscription-dismantle/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
    dev: {
        deleteCustomer(id: string) {
            return postEmpty(`/dev/subscription-dismantle/delete-customer/${id}`);
        },
    },
};
